// api.js
import axios from "axios";

export const API_BASE_URL = "https://api.shinycleaner.com/api";
export const BASE_URL = "https://api.shinycleaner.com";
export const PUBLIC_BASE_URL = "https://api.shinycleaner.com/storage/"; // for media paths

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
